export default {
  pt: {
    // Traduções em português
  },
  en: {
    // Traduções em inglês
  },
}; 